/**
 * Codes d'état d'une ligne de commande à signaler comme problématiques
 * (affichés avec le statut "error" dans le tableau produits).
 */
export const codesEtatLigneEnErreur: readonly number[] = [6, 7, 9, 12, 15, 17, 19, 20, 98];

export default codesEtatLigneEnErreur;
